import { render, staticRenderFns } from "./promptTable.vue?vue&type=template&id=4b206673&scoped=true"
import script from "./promptTable.vue?vue&type=script&lang=js"
export * from "./promptTable.vue?vue&type=script&lang=js"
import style0 from "./promptTable.vue?vue&type=style&index=0&id=4b206673&prod&lang=scss&scoped=true"
import style1 from "./promptTable.vue?vue&type=style&index=1&id=4b206673&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b206673",
  null
  
)

export default component.exports